<template>
  <SubSidebarLayout :menu-categories="menuCategories" />
</template>
<script>
import SubSidebarLayout from '@/components/sidebars/SubSidebarLayout'

export default {
  components: {
    SubSidebarLayout
  },
  data: () => ({
    menuCategories: [
      {
        name: '発注',
        items: [
          {
            text: '校了依頼一覧',
            router: { name: 'masterClientOrders' }
          }
        ]
      }
    ]
  })
}
</script>
